import {
  CLIENT_TSA_ADD_NEW,
  CLIENT_TSA_ADD_NEW_SUCCESS,
  CLIENT_TSA_ADD_NEW_ERROR,
  CLIENT_TSA_EDIT,
  CLIENT_TSA_EDIT_SUCCESS,
  CLIENT_TSA_EDIT_ERROR,
  CLIENT_TSA_GET_BY_QUERY,
  CLIENT_TSA_GET_BY_ID,
  CLIENT_TSA_GET_BY_ID_SUCCESS,
  CLIENT_TSA_GET_BY_ID_ERROR,
  CLIENT_TSA_GET_BY_QUERY_SUCCESS,
  CLIENT_TSA_GET_BY_QUERY_ERROR,
  CLIENT_TSA_ADD_NEW_REQUEST,
  CLIENT_TSA_DELETE,
  CLIENT_TSA_DELETE_ERROR,
} from './types';
// item
const initialState = {
  item: null,
  items: [],
  loading: false,
  error: null,
  itemCount: 0,
  pageCount: 0,
  total: 0,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default function initState(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CLIENT_TSA_ADD_NEW:
    case CLIENT_TSA_DELETE:
    case CLIENT_TSA_GET_BY_ID:
    case CLIENT_TSA_GET_BY_QUERY:
      return {
        ...state,
        loading: true,
        error: null,
        deleteSuccess: true,
        addSuccess: true,
        editSuccess: false,
        item: null,
      };

    case CLIENT_TSA_EDIT:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: true,
      };
    case CLIENT_TSA_EDIT_SUCCESS:
    case CLIENT_TSA_ADD_NEW_REQUEST:
      return {
        ...state,
        loading: false,
        item: null,
        error: null,
      };
    case CLIENT_TSA_ADD_NEW_SUCCESS:
    case CLIENT_TSA_GET_BY_QUERY_SUCCESS:
      const { itemCount, pageCount, total, data } = payload;
      return {
        ...state,
        loading: false,
        items: data,
        total,
        itemCount,
        pageCount,
      };

    case CLIENT_TSA_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
      };

    case CLIENT_TSA_ADD_NEW_ERROR:
    case CLIENT_TSA_DELETE_ERROR:
    case CLIENT_TSA_EDIT_ERROR:
    case CLIENT_TSA_GET_BY_ID_ERROR:
    case CLIENT_TSA_GET_BY_QUERY_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
}
